export default function formatSizeBytes(sizeBytes: number): string {
  const onekb = 1024;
  const onemb = onekb * 1000;
  if (sizeBytes > onemb) {
    const mb = Math.floor(sizeBytes / onemb);
    return mb + "MB";
  } else if (sizeBytes > onekb) {
    const kb = Math.floor(sizeBytes / onekb);
    return kb + "KB";
  } else return sizeBytes.toString() + "B";
}
